import { IEntityInfo, NSARouterMakerResult } from "namirasoft-account-react";
import { ProductUUID } from "namirasoft-api-product";
import { AWSInputRow, AWSRow, AzureInputRow, AzureRow, GCPInputRow, GCPRow, RuleInputRow, RuleRow } from "namirasoft-bill-watch";
import { IStorageLocal } from "namirasoft-core";
import { NamirasoftMap } from "namirasoft-site-map";
import { BaseColumnFormatter, BooleanFormatter, DateTimeFormatter, EnumFormatter, ForeColorFormatter, IDFormatter, IntegerFormatter, JsonFormatter, StringFormatter, StringFormatterSizeType } from "namirasoft-site-react";
import { BillWatchMenus } from "./BillWatchMenus";
import { BillWatchProps } from "./BillWatchProps";
import { BillWatchRoutes } from "./BillWatchRoutes";

export class BillWatchEntities
{
	static aws(props: NSARouterMakerResult & BillWatchProps, showDialog: (id: string) => void): IEntityInfo<AWSRow, AWSInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_BILL_WATCH,
			name: "aws",
			tables: [{ table: namirasoft.bill_watch.tables.aws, required: true }],
			client: {
				getListURL: () => BillWatchRoutes.AWSList,
				getNewURL: () => BillWatchRoutes.AWSNew,
				getCopyURL: (id: string) => BillWatchRoutes.AWSCopy(id),
				getEditURL: (id: string) => BillWatchRoutes.AWSEdit(id),
				getViewURL: (id: string) => BillWatchRoutes.AWSView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.credential_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.account_id, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.topic_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.name, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.active, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.show_api_call, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.show_new_cost, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.show_on_deactive, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.show_on_no_anomaly, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.max_api_call_total, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.max_api_call_per_operation, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.lookback_periods, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.dimensions, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.metrics, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.last_run_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.last_run_status, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.last_run_anomaly_found, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "red", false: "green" })),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.last_run_message, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.next_run_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.aws.columns.updated_at, new DateTimeFormatter()),
					];
				},
				getMenus: (getIDs) => ({ "AWS": [BillWatchMenus.Run(getIDs, showDialog)] })
			},
			server: {
				value_list: props.servers.bill_watch.value.List,
				get: props.servers.bill_watch.aws.Get,
				list: props.servers.bill_watch.aws.List,
				create: props.servers.bill_watch.aws.Create,
				update: props.servers.bill_watch.aws.Update,
				delete: props.servers.bill_watch.aws.Delete,
			}
		};
	}

	static azure(props: NSARouterMakerResult & BillWatchProps, showDialog: (id: string) => void): IEntityInfo<AzureRow, AzureInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_BILL_WATCH,
			name: "azure",
			tables: [{ table: namirasoft.bill_watch.tables.azure, required: true }],
			client: {
				getListURL: () => BillWatchRoutes.AzureList,
				getNewURL: () => BillWatchRoutes.AzureNew,
				getCopyURL: (id: string) => BillWatchRoutes.AzureCopy(id),
				getEditURL: (id: string) => BillWatchRoutes.AzureEdit(id),
				getViewURL: (id: string) => BillWatchRoutes.AzureView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.credential_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.topic_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.name, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.active, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.show_api_call, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.show_new_cost, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.show_on_deactive, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.show_on_no_anomaly, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.max_api_call_total, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.max_api_call_per_operation, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.lookback_periods, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.subscription_id, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.metrics, new EnumFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.last_run_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.last_run_status, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.last_run_anomaly_found, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "red", false: "green" })),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.last_run_message, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.next_run_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.azure.columns.updated_at, new DateTimeFormatter()),
					];
				},
				getMenus: (getIDs) => ({ "Azure": [BillWatchMenus.Run(getIDs, showDialog)] })
			},
			server: {
				value_list: props.servers.bill_watch.value.List,
				get: props.servers.bill_watch.azure.Get,
				list: props.servers.bill_watch.azure.List,
				create: props.servers.bill_watch.azure.Create,
				update: props.servers.bill_watch.azure.Update,
				delete: props.servers.bill_watch.azure.Delete,
			}
		};
	}

	static gcp(props: NSARouterMakerResult & BillWatchProps, showDialog: (id: string) => void): IEntityInfo<GCPRow, GCPInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);
		return {
			product_id: ProductUUID.NAMIRASOFT_BILL_WATCH,
			name: "gcp",
			tables: [{ table: namirasoft.bill_watch.tables.gcp, required: true }],
			client: {
				getListURL: () => BillWatchRoutes.GCPList,
				getNewURL: () => BillWatchRoutes.GCPNew,
				getCopyURL: (id: string) => BillWatchRoutes.GCPCopy(id),
				getEditURL: (id: string) => BillWatchRoutes.GCPEdit(id),
				getViewURL: (id: string) => BillWatchRoutes.GCPView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.credential_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.account_id, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.topic_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.log_group_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.name, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.active, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "green", false: "red" })),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.show_api_call, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.show_new_cost, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.show_on_deactive, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.show_on_no_anomaly, new BooleanFormatter("Yes", "No")),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.max_api_call_total, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.max_api_call_per_operation, new IntegerFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.lookback_periods, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.project_id, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.dimensions, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.last_run_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.last_run_status, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.last_run_anomaly_found, new ForeColorFormatter(new BooleanFormatter("Yes", "No"), { true: "red", false: "green" })),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.last_run_message, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.next_run_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.gcp.columns.updated_at, new DateTimeFormatter()),
					];
				},
				getMenus: (getIDs) => ({ "GCP": [BillWatchMenus.Run(getIDs, showDialog)] })
			},
			server: {
				value_list: props.servers.bill_watch.value.List,
				get: props.servers.bill_watch.gcp.Get,
				list: props.servers.bill_watch.gcp.List,
				create: props.servers.bill_watch.gcp.Create,
				update: props.servers.bill_watch.gcp.Update,
				delete: props.servers.bill_watch.gcp.Delete,
			}
		};
	}

	static rule(props: NSARouterMakerResult & BillWatchProps): IEntityInfo<RuleRow, RuleInputRow>
	{
		let namirasoft = new NamirasoftMap(props.account.token_manager, console.error);

		return {
			product_id: ProductUUID.NAMIRASOFT_BILL_WATCH,
			name: "rule",
			tables: [{ table: namirasoft.bill_watch.tables.rule, required: true }],
			client: {
				getListURL: () => BillWatchRoutes.RuleList,
				getNewURL: () => BillWatchRoutes.RuleNew,
				getCopyURL: (id: string) => BillWatchRoutes.RuleCopy(id),
				getEditURL: (id: string) => BillWatchRoutes.RuleEdit(id),
				getViewURL: (id: string) => BillWatchRoutes.RuleView(id),
				getColumns: () =>
				{
					return [
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.rule.columns.id, new IDFormatter(namirasoft, null)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.rule.columns.user_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.rule.columns.workspace_id, new IDFormatter(namirasoft, new IStorageLocal())),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.rule.columns.name, new StringFormatter(StringFormatterSizeType.TwoWords)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.rule.columns.conditions, new JsonFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.rule.columns.description, new StringFormatter(StringFormatterSizeType.Description)),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.rule.columns.created_at, new DateTimeFormatter()),
						BaseColumnFormatter.getColumn(namirasoft.bill_watch.tables.rule.columns.updated_at, new DateTimeFormatter()),
					];
				}
			},
			server: {
				value_list: props.servers.bill_watch.value.List,
				get: props.servers.bill_watch.rule.Get,
				list: props.servers.bill_watch.rule.List,
				create: props.servers.bill_watch.rule.Create,
				update: props.servers.bill_watch.rule.Update,
				delete: props.servers.bill_watch.rule.Delete,
			}
		};
	}
}